import { render, staticRenderFns } from "./my-input-number.vue?vue&type=template&id=bfd54240&"
import script from "./my-input-number.vue?vue&type=script&lang=js&"
export * from "./my-input-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports